import { css } from '@emotion/css'
import { spacing, fontSize, lineHeight, fontWeight, colors } from '@offerzen/pinata-shame'

const styles = {
  wrapper: css({
    fontSize: fontSize.default,
    lineHeight: lineHeight.default,
    paddingBottom: spacing.default,
    marginBottom: spacing.medium,
    borderBottom: `1px dashed ${colors.mystic}`,
  }),

  heading: css({
    display: 'flex',
    alignItems: 'center',
    marginBottom: spacing.small,
  }),

  position: css({
    fontWeight: fontWeight.medium,
    color: colors.blackPearl,
  }),

  actions: css({
    display: 'flex',
    alignItems: 'center',

    '& > * + *': {
      marginLeft: spacing.small,
    },
  }),

  metadata: css({
    fontSize: fontSize.default,
    color: colors.scorpion,
    fontWeight: fontWeight.medium,
    marginTop: spacing.extraSmall,
  }),

  badgeButton: css({
    marginLeft: 'auto',
    marginRight: spacing.small,
  }),

  notification: css({
    marginTop: spacing.default,
  }),

  action: css({
    textDecoration: 'underline',
  }),
}

export default styles
